import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import axios from "axios";
import toast from "react-hot-toast";
import { API_URL } from "../config";

/* eslint-disable react-hooks/exhaustive-deps */

const PERIYOT_KOLONLAR = [
  { key: "dip_tarama",             label: "Dip Tarama" },
  { key: "likidite_tarama",        label: "Likidite Tarama" },
  { key: "fvg_tarama",             label: "FVG Tarama" },
  { key: "capa_noktasi_tarama",    label: "Çapa Noktası" },
  { key: "msb_tarama",             label: "MSB Tarama" },
  { key: "ote_tarama",             label: "OTE Tarama" },
  { key: "obbb_tarama",            label: "OB & BB Tarama" },
  { key: "idm_tarama",             label: "IDM Tarama" },
  { key: "pd_zone_tarama",         label: "P/D Zone" },
  { key: "smt_tarama",             label: "SMT Tarama" },
  { key: "killzone_tarama",        label: "Killzone" },
  { key: "topdown_cascade",        label: "Topdown Cascade" },
  { key: "hacim_profili_tarama",   label: "Hacim Profili" },
  { key: "hacim_akisi_tarama",     label: "Hacim Akışı" },
  { key: "divergence_tarama",      label: "Divergence" },
  { key: "islem_planlama",         label: "İşlem Planlama" },
  { key: "puanlama_tahmin",        label: "Puanlama & Tahmin" },
  { key: "karar_motoru",           label: "Karar Motoru" },
  { key: "piyasa_rejimi_analizi",  label: "Piyasa Rejimi" },
  { key: "sektorel_guc_rotasyonu", label: "Sektörel Güç Rotasyonu" },
  { key: "haber_duygu_analizi",    label: "Haber Duygu Analizi" },
  { key: "birlesik_skor",          label: "Birleşik Skor" },
  { key: "walk_forward",           label: "Walk Forward" },
  { key: "risk_filtresi",          label: "Risk Filtresi" },
  { key: "yatirim_oneri_motoru",   label: "Yatırım Öneri Motoru" },
];

// Para birimleri için de aynı modül listesi kullanılıyor
const PARA_MODUL_KOLONLAR = PERIYOT_KOLONLAR;

const BOŞ_PARA = () => {
  const obj = { para_birimi: "", BIST: false, Kripto: false };
  PARA_MODUL_KOLONLAR.forEach(k => { obj[k.key] = false; });
  return obj;
};

const BOŞ_PERIYOT = () => {
  const obj = { periyot: "" };
  PERIYOT_KOLONLAR.forEach(k => { obj[k.key] = false; });
  return obj;
};

export default function BakimPaneli() {
  const [token, setToken]       = useState(null);
  const [aktifTab, setAktifTab] = useState("piyasalar");

  // --- piyasalar ---
  const [piyasalar, setPiyasalar]       = useState([]);
  const [yeniPiyasa, setYeniPiyasa]     = useState("");
  const [duzPiyasa, setDuzPiyasa]       = useState(null); // {id, piyasa}

  // --- para birimleri ---
  const [paraBirimleri, setParaBirimleri]   = useState([]);
  const [yeniPara, setYeniPara]             = useState(BOŞ_PARA());
  const [duzPara, setDuzPara]               = useState(null);
  const [acikPara, setAcikPara]             = useState(null); // expanded row id

  // --- periyotlar ---
  const [periyotlar, setPeriyotlar]       = useState([]);
  const [yeniPeriyot, setYeniPeriyot]     = useState(BOŞ_PERIYOT());
  const [duzPeriyot, setDuzPeriyot]       = useState(null);
  const [acikPeriyot, setAcikPeriyot]     = useState(null); // id of expanded row

  // Token al
  useEffect(() => {
    const al = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setToken(session?.access_token || null);
    };
    al();
  }, []);

  const headers = () => ({ Authorization: `Bearer ${token}` });

  // ─── Yükle ────────────────────────────────────────────────────────────────
  useEffect(() => { if (token) { yukle(); } }, [token, aktifTab]);

  const yukle = async () => {
    try {
      if (aktifTab === "piyasalar") {
        const r = await axios.get(`${API_URL}/bakim/piyasalar`, { headers: headers() });
        setPiyasalar(r.data);
      } else if (aktifTab === "para_birimleri") {
        const r = await axios.get(`${API_URL}/bakim/para-birimleri`, { headers: headers() });
        setParaBirimleri(r.data);
      } else {
        const r = await axios.get(`${API_URL}/bakim/periyotlar`, { headers: headers() });
        setPeriyotlar(r.data);
      }
    } catch (e) {
      toast.error("Veri yüklenemedi");
    }
  };

  // ─── Piyasalar CRUD ───────────────────────────────────────────────────────
  const piyasaEkle = async () => {
    if (!yeniPiyasa.trim()) return;
    try {
      await axios.post(`${API_URL}/bakim/piyasalar`, { piyasa: yeniPiyasa }, { headers: headers() });
      setYeniPiyasa("");
      yukle();
      toast.success("Eklendi");
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };

  const piyasaGuncelle = async () => {
    if (!duzPiyasa) return;
    try {
      await axios.put(`${API_URL}/bakim/piyasalar/${duzPiyasa.id}`, { piyasa: duzPiyasa.piyasa }, { headers: headers() });
      setDuzPiyasa(null);
      yukle();
      toast.success("Güncellendi");
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };

  const piyasaSil = async (id) => {
    if (!window.confirm("Silmek istediğinizden emin misiniz?")) return;
    try {
      await axios.delete(`${API_URL}/bakim/piyasalar/${id}`, { headers: headers() });
      yukle();
      toast.success("Silindi");
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };

  // ─── Para Birimleri CRUD ──────────────────────────────────────────────────
  const paraEkle = async () => {
    if (!yeniPara.para_birimi.trim()) return;
    try {
      await axios.post(`${API_URL}/bakim/para-birimleri`, yeniPara, { headers: headers() });
      setYeniPara(BOŞ_PARA());
      yukle();
      toast.success("Eklendi");
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };

  const paraGuncelle = async () => {
    if (!duzPara) return;
    try {
      await axios.put(`${API_URL}/bakim/para-birimleri/${duzPara.id}`, duzPara, { headers: headers() });
      setDuzPara(null);
      yukle();
      toast.success("Güncellendi");
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };

  const paraSil = async (id) => {
    if (!window.confirm("Silmek istediğinizden emin misiniz?")) return;
    try {
      await axios.delete(`${API_URL}/bakim/para-birimleri/${id}`, { headers: headers() });
      yukle();
      toast.success("Silindi");
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };

  // ─── Periyotlar CRUD ──────────────────────────────────────────────────────
  const periyotEkle = async () => {
    if (!yeniPeriyot.periyot.trim()) return;
    try {
      await axios.post(`${API_URL}/bakim/periyotlar`, yeniPeriyot, { headers: headers() });
      setYeniPeriyot(BOŞ_PERIYOT());
      yukle();
      toast.success("Eklendi");
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };

  const periyotGuncelle = async () => {
    if (!duzPeriyot) return;
    try {
      await axios.put(`${API_URL}/bakim/periyotlar/${duzPeriyot.id}`, duzPeriyot, { headers: headers() });
      setDuzPeriyot(null);
      yukle();
      toast.success("Güncellendi");
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };

  const periyotSil = async (id) => {
    if (!window.confirm("Silmek istediğinizden emin misiniz?")) return;
    try {
      await axios.delete(`${API_URL}/bakim/periyotlar/${id}`, { headers: headers() });
      yukle();
      toast.success("Silindi");
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <div style={{ padding: "2rem", background: "#0f172a", minHeight: "100vh", color: "#e2e8f0" }}>
      <h2 style={{ color: "#93c5fd", marginBottom: "1.5rem", fontSize: "20px" }}>
        🔧 Bakım Paneli
      </h2>

      {/* Tab bar */}
      <div style={{ display: "flex", gap: "8px", marginBottom: "1.5rem" }}>
        {[
          { key: "piyasalar",      label: "🌐 Piyasalar" },
          { key: "para_birimleri", label: "💱 Para Birimleri" },
          { key: "periyotlar",     label: "⏱ Periyotlar" },
        ].map(t => (
          <button key={t.key} onClick={() => setAktifTab(t.key)}
            style={{
              padding: "8px 18px", borderRadius: "8px", border: "none", cursor: "pointer",
              fontSize: "13px", fontWeight: aktifTab === t.key ? "700" : "400",
              background: aktifTab === t.key ? "#2563eb" : "#1e293b",
              color: aktifTab === t.key ? "white" : "#94a3b8",
            }}>
            {t.label}
          </button>
        ))}
      </div>

      {/* ── PIYASALAR ─────────────────────────────────────────────────────── */}
      {aktifTab === "piyasalar" && (
        <div style={s.kart}>
          <h3 style={s.kartBaslik}>Piyasalar</h3>

          {/* Ekle */}
          <div style={s.satir}>
            <input value={yeniPiyasa} onChange={e => setYeniPiyasa(e.target.value)}
              placeholder="Yeni piyasa adı..." style={s.input} />
            <button onClick={piyasaEkle} style={s.btnYesil}>+ Ekle</button>
          </div>

          {/* Liste */}
          <table style={s.tablo}>
            <thead><tr>
              <th style={s.th}>Piyasa</th>
              <th style={s.th}>İşlemler</th>
            </tr></thead>
            <tbody>
              {piyasalar.map(p => (
                <tr key={p.id}>
                  <td style={s.td}>
                    {duzPiyasa?.id === p.id
                      ? <input value={duzPiyasa.piyasa}
                          onChange={e => setDuzPiyasa({ ...duzPiyasa, piyasa: e.target.value })}
                          style={{ ...s.input, width: "200px" }} />
                      : p.piyasa
                    }
                  </td>
                  <td style={s.td}>
                    {duzPiyasa?.id === p.id ? (
                      <>
                        <button onClick={piyasaGuncelle} style={s.btnMavi}>Kaydet</button>
                        <button onClick={() => setDuzPiyasa(null)} style={s.btnGri}>İptal</button>
                      </>
                    ) : (
                      <>
                        <button onClick={() => setDuzPiyasa({ ...p })} style={s.btnMavi}>Düzenle</button>
                        <button onClick={() => piyasaSil(p.id)} style={s.btnKirmizi}>Sil</button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ── PARA BİRİMLERİ ────────────────────────────────────────────────── */}
      {aktifTab === "para_birimleri" && (
        <div style={s.kart}>
          <h3 style={s.kartBaslik}>Para Birimleri</h3>

          {/* Ekle formu */}
          <details style={{ marginBottom: "1rem" }}>
            <summary style={{ color: "#93c5fd", cursor: "pointer", marginBottom: "0.5rem" }}>
              + Yeni Para Birimi Ekle
            </summary>
            <div style={{ padding: "1rem", background: "#1e293b", borderRadius: "8px" }}>
              <div style={{ ...s.satir, marginBottom: "0.75rem" }}>
                <input value={yeniPara.para_birimi}
                  onChange={e => setYeniPara({ ...yeniPara, para_birimi: e.target.value })}
                  placeholder="Para birimi adı..." style={{ ...s.input, width: "200px" }} />
                <label style={s.checkLabel}>
                  <input type="checkbox" checked={yeniPara.BIST}
                    onChange={e => setYeniPara({ ...yeniPara, BIST: e.target.checked })} />
                  BIST
                </label>
                <label style={s.checkLabel}>
                  <input type="checkbox" checked={yeniPara.Kripto}
                    onChange={e => setYeniPara({ ...yeniPara, Kripto: e.target.checked })} />
                  Kripto
                </label>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "6px", marginBottom: "0.75rem" }}>
                {PARA_MODUL_KOLONLAR.map(k => (
                  <label key={k.key} style={s.checkLabel}>
                    <input type="checkbox" checked={yeniPara[k.key]}
                      onChange={e => setYeniPara({ ...yeniPara, [k.key]: e.target.checked })} />
                    {k.label}
                  </label>
                ))}
              </div>
              <button onClick={paraEkle} style={s.btnYesil}>+ Ekle</button>
            </div>
          </details>

          {/* Liste */}
          <table style={s.tablo}>
            <thead><tr>
              <th style={s.th}>Para Birimi</th>
              <th style={s.th}>BIST</th>
              <th style={s.th}>Kripto</th>
              <th style={s.th}>Aktif Modüller</th>
              <th style={s.th}>İşlemler</th>
            </tr></thead>
            <tbody>
              {paraBirimleri.map(p => {
                const aktifModuller = PARA_MODUL_KOLONLAR.filter(k => p[k.key]);
                const isDuz = duzPara?.id === p.id;
                return (
                  <>
                    <tr key={p.id}>
                      <td style={s.td}>
                        {isDuz
                          ? <input value={duzPara.para_birimi}
                              onChange={e => setDuzPara({ ...duzPara, para_birimi: e.target.value })}
                              style={{ ...s.input, width: "160px" }} />
                          : <strong style={{ color: "#93c5fd" }}>{p.para_birimi}</strong>
                        }
                      </td>
                      <td style={s.td}>
                        {isDuz
                          ? <input type="checkbox" checked={duzPara.BIST}
                              onChange={e => setDuzPara({ ...duzPara, BIST: e.target.checked })} />
                          : p.BIST ? "✅" : "—"
                        }
                      </td>
                      <td style={s.td}>
                        {isDuz
                          ? <input type="checkbox" checked={duzPara.Kripto}
                              onChange={e => setDuzPara({ ...duzPara, Kripto: e.target.checked })} />
                          : p.Kripto ? "✅" : "—"
                        }
                      </td>
                      <td style={s.td}>
                        {!isDuz && (
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                            {aktifModuller.length === 0
                              ? <span style={{ color: "#64748b", fontSize: "12px" }}>—</span>
                              : aktifModuller.map(k => (
                                <span key={k.key} style={s.badge}>{k.label}</span>
                              ))
                            }
                          </div>
                        )}
                      </td>
                      <td style={s.td}>
                        {isDuz ? (
                          <>
                            <button onClick={paraGuncelle} style={s.btnMavi}>Kaydet</button>
                            <button onClick={() => setDuzPara(null)} style={s.btnGri}>İptal</button>
                          </>
                        ) : (
                          <>
                            <button onClick={() => { setDuzPara({ ...p }); setAcikPara(p.id); }}
                              style={s.btnMavi}>Düzenle</button>
                            <button onClick={() => setAcikPara(acikPara === p.id ? null : p.id)}
                              style={s.btnTuruncu}>
                              {acikPara === p.id ? "Kapat" : "Modüller"}
                            </button>
                            <button onClick={() => paraSil(p.id)} style={s.btnKirmizi}>Sil</button>
                          </>
                        )}
                      </td>
                    </tr>

                    {/* Expanded modül matrisi */}
                    {(acikPara === p.id) && (
                      <tr key={`${p.id}-detail`}>
                        <td colSpan={5} style={{ background: "#1e293b", padding: "1rem" }}>
                          {isDuz ? (
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "6px" }}>
                              {PARA_MODUL_KOLONLAR.map(k => (
                                <label key={k.key} style={s.checkLabel}>
                                  <input type="checkbox" checked={duzPara[k.key]}
                                    onChange={e => setDuzPara({ ...duzPara, [k.key]: e.target.checked })} />
                                  {k.label}
                                </label>
                              ))}
                            </div>
                          ) : (
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "6px" }}>
                              {PARA_MODUL_KOLONLAR.map(k => (
                                <label key={k.key} style={{ ...s.checkLabel, opacity: 0.7 }}>
                                  <input type="checkbox" checked={p[k.key]} disabled />
                                  {k.label}
                                </label>
                              ))}
                            </div>
                          )}
                        </td>
                      </tr>
                    )}
                  </>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* ── PERİYOTLAR ────────────────────────────────────────────────────── */}
      {aktifTab === "periyotlar" && (
        <div style={s.kart}>
          <h3 style={s.kartBaslik}>Periyotlar</h3>

          {/* Ekle formu */}
          <details style={{ marginBottom: "1rem" }}>
            <summary style={{ color: "#93c5fd", cursor: "pointer", marginBottom: "0.5rem" }}>
              + Yeni Periyot Ekle
            </summary>
            <div style={{ padding: "1rem", background: "#1e293b", borderRadius: "8px" }}>
              <div style={{ ...s.satir, marginBottom: "0.75rem" }}>
                <input value={yeniPeriyot.periyot}
                  onChange={e => setYeniPeriyot({ ...yeniPeriyot, periyot: e.target.value })}
                  placeholder="Periyot adı (örn: 2 Saat)" style={s.input} />
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "6px", marginBottom: "0.75rem" }}>
                {PERIYOT_KOLONLAR.map(k => (
                  <label key={k.key} style={s.checkLabel}>
                    <input type="checkbox" checked={yeniPeriyot[k.key]}
                      onChange={e => setYeniPeriyot({ ...yeniPeriyot, [k.key]: e.target.checked })} />
                    {k.label}
                  </label>
                ))}
              </div>
              <button onClick={periyotEkle} style={s.btnYesil}>+ Ekle</button>
            </div>
          </details>

          {/* Liste */}
          <table style={s.tablo}>
            <thead><tr>
              <th style={s.th}>Periyot</th>
              <th style={s.th}>Aktif Modüller</th>
              <th style={s.th}>İşlemler</th>
            </tr></thead>
            <tbody>
              {periyotlar.map(p => {
                const aktifModuller = PERIYOT_KOLONLAR.filter(k => p[k.key]);
                const isDuz = duzPeriyot?.id === p.id;
                return (
                  <>
                    <tr key={p.id}>
                      <td style={s.td}>
                        {isDuz
                          ? <input value={duzPeriyot.periyot}
                              onChange={e => setDuzPeriyot({ ...duzPeriyot, periyot: e.target.value })}
                              style={{ ...s.input, width: "140px" }} />
                          : <strong style={{ color: "#93c5fd" }}>{p.periyot}</strong>
                        }
                      </td>
                      <td style={s.td}>
                        {!isDuz && (
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                            {aktifModuller.length === 0
                              ? <span style={{ color: "#64748b", fontSize: "12px" }}>—</span>
                              : aktifModuller.map(k => (
                                <span key={k.key} style={s.badge}>{k.label}</span>
                              ))
                            }
                          </div>
                        )}
                      </td>
                      <td style={s.td}>
                        {isDuz ? (
                          <>
                            <button onClick={periyotGuncelle} style={s.btnMavi}>Kaydet</button>
                            <button onClick={() => setDuzPeriyot(null)} style={s.btnGri}>İptal</button>
                          </>
                        ) : (
                          <>
                            <button onClick={() => { setDuzPeriyot({ ...p }); setAcikPeriyot(p.id); }}
                              style={s.btnMavi}>Düzenle</button>
                            <button onClick={() => setAcikPeriyot(acikPeriyot === p.id ? null : p.id)}
                              style={s.btnTuruncu}>
                              {acikPeriyot === p.id ? "Kapat" : "Modüller"}
                            </button>
                            <button onClick={() => periyotSil(p.id)} style={s.btnKirmizi}>Sil</button>
                          </>
                        )}
                      </td>
                    </tr>

                    {/* Expanded: modül checkboxları */}
                    {(acikPeriyot === p.id) && (
                      <tr key={`${p.id}-detail`}>
                        <td colSpan={3} style={{ background: "#1e293b", padding: "1rem" }}>
                          {isDuz ? (
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "6px" }}>
                              {PERIYOT_KOLONLAR.map(k => (
                                <label key={k.key} style={s.checkLabel}>
                                  <input type="checkbox" checked={duzPeriyot[k.key]}
                                    onChange={e => setDuzPeriyot({ ...duzPeriyot, [k.key]: e.target.checked })} />
                                  {k.label}
                                </label>
                              ))}
                            </div>
                          ) : (
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "6px" }}>
                              {PERIYOT_KOLONLAR.map(k => (
                                <label key={k.key} style={{ ...s.checkLabel, opacity: 0.7 }}>
                                  <input type="checkbox" checked={p[k.key]} disabled />
                                  {k.label}
                                </label>
                              ))}
                            </div>
                          )}
                        </td>
                      </tr>
                    )}
                  </>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const s = {
  kart:      { background: "#1e293b", borderRadius: "12px", padding: "1.5rem" },
  kartBaslik:{ color: "#93c5fd", fontSize: "16px", fontWeight: "600", marginBottom: "1rem" },
  satir:     { display: "flex", gap: "10px", alignItems: "center", marginBottom: "1rem", flexWrap: "wrap" },
  input:     { background: "#0f172a", border: "1px solid #334155", borderRadius: "6px",
               color: "#e2e8f0", padding: "6px 10px", fontSize: "13px", outline: "none" },
  tablo:     { width: "100%", borderCollapse: "collapse", fontSize: "13px" },
  th:        { textAlign: "left", padding: "8px 12px", borderBottom: "1px solid #334155",
               color: "#64748b", fontWeight: "600" },
  td:        { padding: "8px 12px", borderBottom: "1px solid #1e293b", verticalAlign: "middle" },
  btnYesil:  { background: "#16a34a", color: "white", border: "none", borderRadius: "6px",
               padding: "6px 14px", cursor: "pointer", fontSize: "12px", fontWeight: "600" },
  btnMavi:   { background: "#2563eb", color: "white", border: "none", borderRadius: "6px",
               padding: "5px 12px", cursor: "pointer", fontSize: "12px", marginRight: "6px" },
  btnKirmizi:{ background: "#dc2626", color: "white", border: "none", borderRadius: "6px",
               padding: "5px 12px", cursor: "pointer", fontSize: "12px" },
  btnGri:    { background: "#475569", color: "white", border: "none", borderRadius: "6px",
               padding: "5px 12px", cursor: "pointer", fontSize: "12px", marginRight: "6px" },
  btnTuruncu:{ background: "#d97706", color: "white", border: "none", borderRadius: "6px",
               padding: "5px 12px", cursor: "pointer", fontSize: "12px", marginRight: "6px" },
  checkLabel:{ display: "flex", alignItems: "center", gap: "6px", fontSize: "12px",
               color: "#cbd5e1", cursor: "pointer" },
  badge:     { background: "#1d4ed8", color: "#bfdbfe", padding: "2px 8px",
               borderRadius: "12px", fontSize: "11px" },
};
